<template>
  <section class="cn-about-text-section">
    <div class="container">
      <div class="cn-about-text-section__row">
        <div
          v-for="(item, i) in data.items ?? []"
          :key="i"
          class="cn-about-text-section__item"
          :class="{ 'cn-about-text-section__item-odd': i % 2 !== 0 }"
        >
          <h2 class="cn-about-text-section__item-title">
            {{ item.title }}
          </h2>
          <p class="cn-about-text-section__item-description">
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
interface Props {
  data: {
    items: {
      title?: string;
      description?: string;
    }[];
  };
}
defineProps<Props>();
</script>

<style lang="scss">
.cn-about-text-section {
  --ab-canyon-about-text-section-title-color-text: var(
    --ab-canyon-color-primary
  );
  --ab-canyon-about-text-section-description-color-text: var(
    --ab-canyon-color-neutral-dark
  );
  padding-top: var(--size-3xl);
  padding-bottom: var(--size-3xl);
  &__row {
    > :not([hidden]) {
      ~ :not([hidden]) {
        margin-top: var(--size-base);
      }
    }
  }
  &__item {
    column-gap: var(--size-5xl);
    align-items: center;
    flex-direction: column;
    max-width: 990px;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 656px) {
      flex-direction: row;
    }
    @media (min-width: 1280px) {
      column-gap: var(--size-7xl);
    }
    &-odd {
      .cn-about-text-section {
        &__item-title {
          @media (min-width: 656px) {
            order: 9999;
          }
        }
      }
    }
  }
  &__item-title {
    color: var(--ab-canyon-about-text-section-title-color-text);
    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.25;
    text-align: center;
    flex-shrink: 0;
    @media (min-width: 656px) {
      text-align: left;
    }
    @media (min-width: 992px) {
      font-size: 2.25rem;
      line-height: 2.5rem;
    }
    @media (min-width: 1280px) {
      line-height: 1.25;
    }
    @media (min-width: 1656px) {
      font-size: 3rem;
      line-height: 1;
    }
  }
  &__item-description {
    color: var(--ab-canyon-about-text-section-description-color-text);
    font-size: 0.875rem;
    line-height: 1.25rem;
    text-align: center;
    max-width: 410px;
    margin-top: calc(var(--size-base) / 4);
    @media (min-width: 656px) {
      font-size: 1rem;
      line-height: 1.25;
      text-align: left;
    }
    @media (min-width: 992px) {
      margin-top: 0px;
    }
  }
}
</style>
